export const offerInfoDataTest = 'text-offerInfo';
export const offerLogoDataTest = 'image-offerLogo';
export const offerDataTest = 'div-offerBox';
